var angular = require('angular');
var jQuery = require('jquery');
var ngDialog = require('ng-dialog');

var imagesLoaded = require('imagesloaded');
imagesLoaded.makeJQueryPlugin(jQuery);

/*--------------------------------------------------------------
 ## Create App
 --------------------------------------------------------------*/
var BLEFA = angular.module('BLEFA', ['ngDialog']);




// WEBPACK FOOTER //
// ./src/assets/js/app.js